import React from "react";
import { Redirect } from "react-router";

export function HomePage() {
  return <Redirect to="/manage" />;
}
